export default __webpack_public_path__ + "static/media/YAS0080.34I-29703_-17146_0.f0bba6d5.jpg";